import React, { useState } from 'react';
import './NavbarComponent.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX, faBars } from '@fortawesome/free-solid-svg-icons';

const NavbarComponent = () => {
  const [showMenu, setShowMenu] = useState(false);

  const toggleMenu = () => {
    console.log(showMenu)
    setShowMenu(!showMenu);
  };

  const hideMenu = () => {
    setShowMenu(false);
  };

  return (
    <div className='navbar'>
      <div className='logo'>Kalyan<span className='kafle'>Kafle</span></div>
      <div className={`nav-links ${showMenu ? 'show' : ''}`}>
        <FontAwesomeIcon className='x-icon' icon={faX} onClick={hideMenu} />
        <ul className='nav-ul'>
        <li>
            <a href='#profile' onClick={hideMenu}>
              Home
            </a>
          </li>
          
          <li>
            <a href='#about' onClick={hideMenu}>
              About
            </a>
          </li>
          <li>
            <a href='#experience' onClick={hideMenu}>
              Skills
            </a>
          </li>
          <li>
            <a href='#projects' onClick={hideMenu}>
              Projects
            </a>
          </li>
          <li>
            <a href='#contact' onClick={hideMenu}>
              Contact
            </a>
          </li>
        </ul>
      </div>
      <FontAwesomeIcon
        className={`bars-icon ${showMenu ? 'hide' : ''}`}
        icon={faBars}
        onClick={toggleMenu}
      />
    </div>
  );
};

export default NavbarComponent;
